import React, { useContext, useEffect, useRef, useState } from 'react'
import { Helmet } from 'react-helmet'
import SimpleReactValidator from 'simple-react-validator'
import { userInformation, updateUserInformation } from '../../../service/userService'
import { errorMessage, successMessage } from '../../../utils/toastMessage'
//third party
import { useSelector, useDispatch } from 'react-redux'
const CompleteInformations = () => {


    const user = useSelector((state) => state.user)

    const [getName, setName] = useState("")
    const [getNumber, setNumber] = useState("")
    const [getNCode, setNCode] = useState("")
    const [getSCode, setSCode] = useState("")
    const [getField, setField] = useState("")
    const [getUni, setUni] = useState("")
    const [getEmail, setEmail] = useState("")
    const [, setForceUpdate] = useState()
    const [getIsStudent, setIsStudent] = useState(false)

    const validator = useRef(
        new SimpleReactValidator({
            messages: {
                required: "پر کردن این فیلد الزامی میباشد",
                min: "تعداد رقم نا معتبر است",
                max: "تعداد رقم نا معتبر است",
                numeric: "این فیلد باید شامل اعداد باشد",
                email: "ایمیل نوشته شده صحیح نمی باشد",
            },
            element: (message) => <span className='a-fs-8'>{message}</span>,
        })
    );



    const handleAnimationForInputLabelsFocus = (index) => {
        document.querySelectorAll("label")[index].style.top = "-15px"
    }
    const handleAnimationForInputLabelsBlur = (e, index) => {
        if (e.target.value.length == 0) {
            document.querySelectorAll("label")[index].style.top = "0px"
        }
    }

    const handleSend = async (e) => {
        e.preventDefault();
        const informations = {
            email: getEmail,
            phoneNumber: getNumber,
            isStudent: getIsStudent,
            name: getName,
            nationalCode: getNCode,
            studentCode: getSCode,
            uni:getUni,
            field:getField
        }
        try {
            if (validator.current.allValid()) {
                const { status, data } = await updateUserInformation(informations);
                console.log(status);
                if (status === 200) {
                    successMessage("اطلاعات با موفقیت ثبت شد")
                    var newInfo = user.value
                    newInfo.name = getName



                }
            }

            else {
                validator.current.showMessages();
                setForceUpdate(1)
            }
        } catch (ex) {
            if (ex.response.status === 401) {
                errorMessage("نام کاربری یا رمز عبور اشتباه میاشد")
            }
        }


    }

    const handleGetInformation = async () => {


        try {
            const { status, data } = await userInformation();
            if (status === 200) {
                setName(data.data.name)
                setEmail(data.data.email)
                setIsStudent(data.data.isStudent)
                setNCode(data.data.nationalCode)
                setSCode(data.data.studentCode)
                setNumber(data.data.phoneNumber)
                setField(data.data.field)
                setUni(data.data.uni)

            }
        } catch (ex) {
        }

    }
    useEffect(() => {
        handleGetInformation()
    }, [])
    return (
        <>
            <Helmet>
                <title> حساب کاربری |  نمایش و تکمیل اطلاعات </title>
            </Helmet>
            <div className='header'>
                <h3>تکمیل و نمایش اطلاعات</h3>
            </div>
            <div className='body-user-information'>
                <form action="" onSubmit={(e) => handleSend(e)}>


                    <div className='input-group'>
                        <label
                            className='a-fs-10'
                            htmlFor="username"
                        >
                            : نام و نام خانوادگی
                        </label>
                        <input
                            autoComplete="off"
                            className='a-fs-10'
                            id='username' type="text"
                            onChange={(e) => {
                                setName(e.target.value);
                                validator.current.showMessageFor(
                                    "name"
                                );
                            }}
                            value={getName}
                            onBlur={(e) => {
                                handleAnimationForInputLabelsBlur(e, 0)
                            }}
                            onFocus={() => {
                                handleAnimationForInputLabelsFocus(0)
                            }} />

                        {validator.current.message(
                            "name",
                            getName,
                            "required"
                        )}
                    </div>



                    <div className='input-group'>
                        <label
                            className='a-fs-10'
                            htmlFor="ncode"
                        >
                            :  کد ملی
                        </label>
                        <input
                            autoComplete="off"
                            className='a-fs-10'
                            id='ncode' type="ncode"
                            onChange={(e) => {
                                setNCode(e.target.value);
                                validator.current.showMessageFor(
                                    "ncode"
                                );
                            }}
                            value={getNCode}
                            onBlur={(e) => {
                                handleAnimationForInputLabelsBlur(e, 1)
                            }}
                            onFocus={() => {
                                handleAnimationForInputLabelsFocus(1)
                            }} />

                        {validator.current.message(
                            "ncode",
                            getNCode,
                            "required|numeric|min:10|max:10"
                        )}
                    </div>

                    <div className='input-group'>
                        <label
                            className='a-fs-10'
                            htmlFor="email"
                        >
                            : ایمیل
                        </label>
                        <input
                            autoComplete="off"
                            className='a-fs-10'
                            id='email' type="text"
                            onChange={(e) => {
                                setEmail(e.target.value);
                                validator.current.showMessageFor(
                                    "email"
                                );
                            }}
                            value={getEmail}
                            onBlur={(e) => {
                                handleAnimationForInputLabelsBlur(e, 2)
                            }}
                            onFocus={() => {
                                handleAnimationForInputLabelsFocus(2)
                            }} />

                        {validator.current.message(
                            "email",
                            getEmail,
                            "required|email"
                        )}
                    </div>


                    <div className='input-group'>
                        <label
                            className='a-fs-10'
                            htmlFor="num"
                        >
                            :  شماره تلفن
                        </label>
                        <input
                            autoComplete="off"
                            className='a-fs-10'
                            id='num' type="text"
                            onChange={(e) => {
                                setNumber(e.target.value);
                                validator.current.showMessageFor(
                                    "num"
                                );
                            }}
                            value={getNumber}
                            onBlur={(e) => {
                                handleAnimationForInputLabelsBlur(e, 3)
                            }}
                            onFocus={() => {
                                handleAnimationForInputLabelsFocus(3)
                            }} />

                        {validator.current.message(
                            "num",
                            getNumber,
                            "required|numeric|min:11|max:11"
                        )}
                    </div>



                    <div className='input-group'>
                        <label
                            className='a-fs-10'
                            htmlFor="isStudent"
                        >
                            آیا دانشجو هستید ؟
                        </label>
                        <input
                            checked={getIsStudent}
                            autoComplete="off"
                            className='a-fs-10'
                            type="checkbox"
                            id='isStudent'
                            onChange={() => {
                                setIsStudent(!getIsStudent)
                            }}
                        />
                    </div>

                    {getIsStudent ? (
                        <>
                            <div className='input-group'>
                                <label
                                    className='a-fs-10'
                                    htmlFor="scode"
                                >
                                    :  شماره دانشجویی
                                </label>
                                <input
                                    autoComplete="off"
                                    className='a-fs-10'
                                    id='scode' type="text"
                                    onChange={(e) => {
                                        setSCode(e.target.value);
                                        validator.current.showMessageFor(
                                            "scode"
                                        );
                                    }}
                                    value={getSCode}
                                    onBlur={(e) => {
                                        handleAnimationForInputLabelsBlur(e, 5)
                                    }}
                                    onFocus={() => {
                                        handleAnimationForInputLabelsFocus(5)
                                    }} />

                                {validator.current.message(
                                    "scode",
                                    getSCode,
                                    "required|numeric"
                                )}
                            </div>



                            <div className='input-group'>
                                <label
                                    className='a-fs-10'
                                    htmlFor="field"
                                >
                                    :   رشته
                                </label>
                                <input
                                    autoComplete="off"
                                    className='a-fs-10'
                                    id='field' type="text"
                                    onChange={(e) => {
                                        setField(e.target.value);
                                        validator.current.showMessageFor(
                                            "field"
                                        );
                                    }}
                                    value={getField}
                                    onBlur={(e) => {
                                        handleAnimationForInputLabelsBlur(e, 6)
                                    }}
                                    onFocus={() => {
                                        handleAnimationForInputLabelsFocus(6)
                                    }} />

                                {validator.current.message(
                                    "field",
                                    getField,
                                    "required"
                                )}
                            </div>


                            <div className='input-group'>
                                <label
                                    className='a-fs-10'
                                    htmlFor="uni"
                                >
                                    :   دانشگاه
                                </label>
                                <input
                                    autoComplete="off"
                                    className='a-fs-10'
                                    id='uni' type="text"
                                    onChange={(e) => {
                                        setUni(e.target.value);
                                        validator.current.showMessageFor(
                                            "uni"
                                        );
                                    }}
                                    value={getUni}
                                    onBlur={(e) => {
                                        handleAnimationForInputLabelsBlur(e, 7)
                                    }}
                                    onFocus={() => {
                                        handleAnimationForInputLabelsFocus(7)
                                    }} />

                                {validator.current.message(
                                    "uni",
                                    getUni,
                                    "required"
                                )}
                            </div>
                        </>











                    ) : (
                        null
                    )}



                    <button className='a-fs-12' type='submit'>ثبت اطلاعات</button>


                </form>
            </div>
        </>
    )

}



export default CompleteInformations